import { useMemo } from "react";

import { EntityHelper } from "@/common/helpers/entity";
import { BaseEntityDtoAny, EntityMeta } from "@/common/ts/entity";

import { useCurrentTenant } from "./tenant/useCurrentTenant";

interface Props {
  entity: Nil<BaseEntityDtoAny>;
}

export function useEntityMeta({ entity }: Props): EntityMeta | null {
  const currentTenant = useCurrentTenant();
  const meta = useMemo(
    () => EntityHelper.getEntityMeta(entity, currentTenant),
    [entity, currentTenant],
  );
  return meta;
}
